import _ from 'lodash';

// To get the path array in Firefox/Safari
export const getPathFromEvent = (event) => {
  const path = _.get(event, 'path', []);
  if (!_.isEmpty(path)) {
    return path;
  }
  if (!('path' in event)) {
    let currentElem = event.target;
    while (currentElem) {
      path.push(currentElem);
      currentElem = currentElem.parentElement;
    }
    if (path.indexOf(window) === -1 && path.indexOf(document) === -1) {
      path.push(document);
    }
    if (path.indexOf(window) === -1) {
      path.push(window);
    }
  }
  return path;
};
